export enum NotifyListSections {
  REQUESTED = 'requested',
  FULFILLED = 'fulfilled',
  NOTIFIED = 'notified',
}

export enum NotifyListDisplayTypes {
  HEADER = 'header',
  PARTY = 'party',
}
